<template>
    <div>
        <!-- contract edit -->
        <d-contract-mnt-edit
            v-model      = "create.mnt"
            :contract-id = "-1"
            :company-id  = "companyId"
            @saved       = "onSaved"
        />
        <!-- contract edit -->

        <!-- contract edit -->
        <d-contract-esc-edit
            v-model      = "create.esc"
            :contract-id = "-1"
            :company-id  = "companyId"
            @saved       = "onSaved"
        />
        <!-- contract edit -->

        <c-contract-card-iterator
            :items          = "contracts"
            :force-deselect = "contactId"
            :selected       = selected
            :item-height    = "null"
            :filter-height  = "280"
            :filter         = "textfilter"
            ref             = "contracts"
        >
            <template v-slot:toolbar>
                <div class="v-flex">
                    <c-header-button label="W" @click = "onMntCreate" :tooltip="$t('contract.create.mnt')" />
                    <c-header-button label="N" @click = "onEscCreate" :tooltip="$t('contract.create.esc')" />
                </div>
            </template>
            <template v-slot:filter>
                <c-contract-service-card-filter
                    v-model = "filter"
                    @input  = "onFilterChanged"
                />
            </template>
            <template v-slot:card="{ item }">
                <c-contract-mnt-card
                    v-if        = "item.item.type.id === 3"
                    :contract   = "item.item"
                    :background = "`background-unset`"
                    :class      = "{ 'contract-inactive': !item.item.active }"
                    v-on        = "item.item.active ? { selected: onSelected } : {}"
                    @saved      = "onSaved"
                />

                <c-contract-esc-card
                    v-if        = "item.item.type.id === 4"
                    :contract   = "item.item"
                    :background = "`background-unset`"
                    :class      = "{ 'contract-inactive': !item.item.active }"
                    v-on        = "item.item.active ? { selected: onSelected } : {}"
                    @saved      = "onSaved"
                />

            </template>
        </c-contract-card-iterator>
    </div>
</template>

<script>

import Core                       from "@/modules/core/service/Core";
import Contract                   from "@/modules/msd/company/contract/service/Contract";
import CContractCardIterator      from "@/modules/msd/company/contract/components/controls/CContractCardIterator";
import CContractMntCard           from "@/modules/msd/company/contract/components/controls/mnt/CContractMntCard";
import DContractMntEdit           from "@/modules/msd/company/contract/components/controls/mnt/DContractMntEdit";
import CContractEscCard           from "@/modules/msd/company/contract/components/controls/esc/CContractEscCard";
import DContractEscEdit           from "@/modules/msd/company/contract/components/controls/esc/DContractEscEdit";
import CContractServiceCardFilter from "@/modules/msd/company/contract/components/controls/CContractServiceCardFilter";
import CHeaderButton              from "@/modules/core/components/utils/CHeaderButton";

export default {
    name: "CContractServiceCardIterator",

    components: {
        CHeaderButton,
        CContractServiceCardFilter,
        DContractEscEdit,
        CContractEscCard,
        DContractMntEdit,
        CContractMntCard,
        CContractCardIterator,
    },

    props: {
        items: {

        },

        customerId: {

        },

        companyId: {

        },

        contactId: {

        }
    },

    data: () => ({
        create  : {
            mnt: false,
            esc: false
        },
        selected: null,
        contract: null,
        contracts: null,
        filter  : {
            types   : ["MNT", "ESC"],
            active  : true,
            inactive: false,
            customer: null,
            role    : 1
        }
    }),


    mounted() {
        if (this.items) {
            this.contracts = this.items.map(contract => ({
                ...contract,
                size: contract.type.id === 3 ? 177 : 120
            }));
            this.emitVisibleContracts();
        }
    },

    watch: {
        items () {
            if (!this.items) {
                this.contracts = null;
                this.emitVisibleContracts();
                return;
            }

            this.contracts = this.items.map(contract => ({
                ...contract,
                size: contract.type.id === 3 ? 177 : 120
            }));
            this.emitVisibleContracts();
        }
    },

    methods: {
        onMntCreate () {
            this.create.mnt = true;
        },

        onEscCreate () {
            this.create.esc = true;
        },

        onSelected (contract) {
            if (this.selected && this.selected.id === contract.id) {
                this.selected = null;
                Core.fire.selected(this, null);
                return;
            }

            this.selected = contract;
            Core.fire.selected(this,  this.selected);
        },

        select (contract) {
            this.selected = contract;
            Core.fire.selected(this,  this.selected);
        },

        onFilterChanged() {
            Contract.list(this.companyId, this.createContractFilter(), (data) => {
                // Don't mutate the prop - emit to parent instead
                this.$emit("update:items", data);
                // Emit event so parent can update site filter
                this.$emit("filter-changed", this.filter);
            });
        },

        onSaved (contract) {
            this.$refs.contracts.refresh(contract);
        },

        createContractFilter() {
            this.filter.customer = this.customerId;
            return this.filter;
        },

        emitVisibleContracts() {
            // Only emit active contracts for site filtering
            // Inactive contracts are shown in the list but their sites are hidden
            const visible = this.contracts ? this.contracts.filter(c => c.active) : [];
            this.$emit("contracts-changed", visible);
        },

        textfilter (item, search) {
            if (!search) {
                return true;
            }

            if (this.includes(item.id.toString(), search)) {
                return true;
            }

            if (item.contracttype) {
                if (this.includes(item.contracttype.name, search)) {
                    return true;
                }
            }

            if (this.includes(item.customer.name, search)) {
                return true;
            }

            return false;
        },

        includes (text, search) {
            if (!text) {
                return false;
            }

            return text.toUpperCase().includes(search.toUpperCase())
        }
    }
}
</script>

<style scoped>

.contract-inactive ::v-deep .v-card {
    cursor: default !important;
}

::v-deep .customer-name {
    font-size: 14px;
    margin-top: 4px;
    margin-bottom: 2px;
    font-weight: 600;
}

</style>